import { connect } from 'react-redux'

import{
  getOutput,
  getRCLookupData,
  getUserData,
  setUserRcData,
  changeInput,
  raiseError,
} from 'state/actions'

function mapStateToProps(state) {
  return {
    chartData: state.chartData,
    sensitivityData: state.sensitivityData,
    totalContributionsTaxable: state.totalContributionsTaxable,
    totalContributionsNonTaxable: state.totalContributionsNonTaxable,

    retirementAge: state.retirementAge,
    retirementAnnualIncome: state.retirementAnnualIncome,
    afterTaxContributions: state.afterTaxContributions,

    userId: state.userId,
    userData: state.userData,
    input: state.input,

    forecast: state.forecast,
    return_and_tax: state.return_and_tax,
    agg_tax_type: state.agg_tax_type,
    isValidated: state.isValidated
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  	getOutput(input) {
    	dispatch(getOutput(input))
  	},
    getRCLookupData(){
      dispatch(getRCLookupData())
    },
    getUserData(userId){
      dispatch(getUserData(userId))
    },
    setUserRcData(input){
      dispatch(setUserRcData(input))
    },
    changeInput(input){
      dispatch(changeInput(input))
    },
    raiseError(){
      dispatch(raiseError())
    }
  }
}

export default function (component) {
  return connect(mapStateToProps, mapDispatchToProps)(component)
}


// WEBPACK FOOTER //
// ./modules/retirement-calculator/app-container.js